import {DateAdapterInterface} from "@/libs/dates/DateAdatperInterface";
import {MomentAdapter} from "@/libs/dates/MomentAdapter";

export type DateInput = string | number | Date;

export class DateAdapterFactory {
    static create(input?: DateInput, locale: string = 'en'): DateAdapterInterface {
        return new MomentAdapter(input, locale);
    }
}
